import { getNumberString } from 'utilities/primitives/convertPrimitiveTypes.js';
import { StatusRating } from './status-rating.js';

export interface IRating {
  colorClass: string;
  textColorClass: string;
  label: string;
  icon: string;
  severityClass?: StatusRating;
}

const GOOD: IRating = {
  colorClass: 'is-good',
  textColorClass: 'u-textGreen',
  label: 'Good',
  icon: 'good',
  severityClass: StatusRating.statusGood,
};

const MEDIUM: IRating = {
  colorClass: 'is-medium',
  textColorClass: 'u-textMedium',
  label: 'Medium',
  icon: 'medium',
  severityClass: StatusRating.statusMedium,
};

const BAD: IRating = {
  colorClass: 'is-bad',
  textColorClass: 'u-textRed',
  label: 'Bad',
  icon: 'bad',
  severityClass: StatusRating.statusBad,
};

const NONE: IRating = {
  colorClass: 'u-textSlate',
  textColorClass: 'u-textSlate',
  label: 'None',
  icon: 'none',
};

export function getRating(_rating?: number | string): IRating {
  const rating = getNumberString(_rating).value ?? 0;

  if (rating >= 1 && rating <= 3) {
    return BAD;
  }
  if (rating >= 4 && rating <= 6) {
    return MEDIUM;
  }
  if (rating >= 7 && rating <= 10) {
    return GOOD;
  }

  return NONE;
}
